import RejectStatusItem from '../../../assets/svg/reject-status-item';
import CancelStatusItem from '../../../assets/svg/cancel-status-item';
import LightCompleteStatusItem from '../../../assets/svg/cancel-status-item copy';

interface StatusItemProps {
  variant?: string;
  isActive?: boolean;
  color?: string;
}

function StatusItem({ variant = "default", isActive = true, color, ...props }: StatusItemProps) {
  const style = color ? {backgroundColor: color} : {}
  
  switch (variant) {
    case "default_horizontal":
      return <div aria-disabled={!isActive} className={`polymer-status-item__default-horizontal ${isActive ? 'polymer-status-item__active' : 'polymer-status-item__disabled'}`} style={style} data-testid="status-item" />
    case "default":
      return <div aria-disabled={!isActive} className={`polymer-status-item__default ${isActive ? 'polymer-status-item__active' : 'polymer-status-item__disabled'}`} style={style} data-testid="status-item" />
    case "dot":
      return <div aria-disabled={!isActive} className={`polymer-status-item__dot ${isActive ? 'polymer-status-item__active' : 'polymer-status-item__disabled'} `} style={style} data-testid="status-item" />
    case "pending":
      return (
        <div className="polymer-status-item__complete">
          <i className="bi bi-three-dots polymer-status-item__complete__tick"></i>
        </div>
      )
    case "reject":
      return (
        <RejectStatusItem />
      )
    case "cancel":
      return (
        <CancelStatusItem />
      )
    case "light_complete":
      return(
        <LightCompleteStatusItem />
      )
    case "complete":
      return (
        <div aria-disabled={!isActive} className={`polymer-status-item__complete ${isActive ? 'polymer-status-item__complete-active' : ''} `} style={style}>
          <i aria-disabled={!isActive} className={`bi bi-check-lg polymer-status-item__complete__tick ${isActive ? 'polymer-status-item__complete-tick_active' : ''}`} style={style}></i>
        </div>
      )
    default:
      return null
  }
}

export default StatusItem